<template>
	<div>
		<topback title="Buy Itoken details" path="back">
			<template slot="right">
				<iconimg class="rechargelog-img" name="deposithistory" @click="go_deposithistory"></iconimg>
			</template>
		</topback>
		<md-field class="mt-6 mb-3 payfor">
			<md-notice-bar icon="warn" mode="link" type="warning" style="margin-top:10px;">
				<vuejsCountDown :end="end" v-if="end !== ''"></vuejsCountDown>
				<span v-else>Please change order status</span>
				<iconimg name="warning" slot="right" @click="warning" />
			</md-notice-bar>
			<md-field-item title="Specified Tool" is-title-latent :content="selectorValue" @click="showSelector" arrow solid >
				<p slot="children" style="color: red;">
					Notice: Please choose the collection tool that has been linked to kyc to make payment, otherwise the transaction cannot be completed.
				</p>
			</md-field-item>
			
			<md-field-item title="Amount" is-title-latent :content="orderdata.amount" solid>
				<md-button class="copy" :data-clipboard-text="orderdata.amount" @click="onCopy" type="primary" plain
					slot="right">Copy</md-button>
					<p slot="children" style="color: red;">
						Notice: The remittance amount must be consistent, otherwise the transaction will not be completed.
					</p>
			</md-field-item>

			<div v-if="orderdata.pay_type === 'bank'">
				<md-field-item title="Name" is-title-latent :content="orderdata.pay_recipients_name" solid>
					<md-button class="copy" :data-clipboard-text="orderdata.pay_recipients_name" @click="onCopy"
						type="primary" plain slot="right">Copy</md-button>
				</md-field-item>

				<md-field-item title="Bank" is-title-latent
					:content="orderdata.pay_bankname ? orderdata.pay_bankname : 'NA'" solid>
					<md-button class="copy" :data-clipboard-text="orderdata.pay_bankname ? orderdata.pay_bankname : 'NA'"
						@click="onCopy" type="primary" plain slot="right">Copy</md-button>
				</md-field-item>

				<md-field-item title="IFSC" is-title-latent :content="orderdata.pay_ifsc" solid>
					<md-button class="copy" :data-clipboard-text="orderdata.pay_ifsc" @click="onCopy" type="primary" plain
						slot="right">Copy</md-button>
				</md-field-item>

				<md-field-item title="account" is-title-latent :content="orderdata.pay_bank_account" solid>
					<md-button class="copy" :data-clipboard-text="orderdata.pay_bank_account" @click="onCopy" type="primary"
						plain slot="right">Copy</md-button>
				</md-field-item>
			</div>

			<div>
				<md-field-item title="UPI" is-title-latent :content="orderdata.pay_upiid ? orderdata.pay_upiid : 'NA'"
					solid>
					<md-button class="copy" :data-clipboard-text="orderdata.pay_upiid ? orderdata.pay_upiid : 'NA'"
						@click="onCopy" type="primary" plain slot="right">Copy</md-button>
				</md-field-item>
			</div>

			<md-field-item title="status" is-title-latent :content="get_order_status(orderdata.collection_status)" solid>
				<md-button type="warning" class="cancel" round slot="right"
					v-if="orderdata.collection_status === 'dispatched' || orderdata.collection_status === 'reprocess'"
					@click="cancel">Cancel</md-button>
				<p slot="children" style="color: red;">
					Notice: If you have already paid, please wait patiently for the transaction review, please do not cancel the order
				</p>
			</md-field-item>
			<md-field-item title="Reason For Rejection" v-if="orderdata.reason_for_rejection">
				<p slot="children" style="color: green;">
					{{ orderdata.reason_for_rejection }}
				</p>
			</md-field-item>

			<md-field-item title="Upload remittance certificate">
				<div class="md-example-child md-example-child-reader md-example-child-reader-0" slot="children">
					<ul class="image-reader-list">
						<li class="image-reader-item" v-for="(img, index) in imageList" :key="index" :style="{
							'backgroundImage': `url(${img})`,
							'backgroundPosition': 'center center',
							'backgroundRepeat': 'no-repeat',
							'backgroundSize': 'cover'
						}">
							<md-tag class="image-reader-item-del" size="small" shape="quarter" fill-color="#111A34"
								type="fill" font-color="#fff" @click.native="onDeleteImage(index)">
								<md-icon name="close"></md-icon>
							</md-tag>
						</li>
						<li class="image-reader-item add" v-if="imageList.length < 3">
							<md-image-reader name="reader0" @select="onReaderSelect" @complete="onReaderComplete"
								@error="onReaderError" is-multiple></md-image-reader>
							<md-icon name="camera" size="md" color="#CCC"></md-icon>
							<p>Upload</p>
						</li>
					</ul>
				</div>
				<p slot="children"></p>
			</md-field-item>

			<md-selector class="active_ct" v-model="isSelectorShow" :data="available_ct" hide-title-bar large-radius
				is-check iconSize="lg" @choose="onSelectorChoose">
				<div class="selector-header" slot="header">
					Choose the specified tool to pay
				</div>
				<template slot-scope="{ option, index, selected }">
					<div class="selector-item-body" :class="{ disabled: option.disabled, selected }">
						<div class="selector-item-left">
							<iconimg :name="option.text"></iconimg>
						</div>
						<div class="selector-item-content">
							<p class="selector-item-title" v-text="option.text"></p>
							<p class="selector-item-brief" v-text="`${option.describe}`"></p>
						</div>
					</div>
				</template>
				<div class="selector-footer" slot="footer">
					<span @click="go_manage_kyc">Manage kyc partner</span>
				</div>
			</md-selector>

		</md-field>
		<md-button type="primary" @click="confirm_payment">Confirm Order</md-button>

		<md-dialog title="why cancel" :closable="true" v-model="canceldialog.open" :btns="canceldialog.btns">
			<md-radio-list :options="cancel_reasons" v-model="cancel_remark" icon="right" icon-inverse="" icon-disabled=""
				icon-position="right" has-input input-label="Other" input-placeholder="Please enter a reason" />
		</md-dialog>
	</div>
</template>

<script>
import topback from '@/components/topback'
import iconimg from '@/components/iconimg'
import vuejsCountDown from '@/components/countdown'
import Clipboard from "clipboard"
import { Dialog, Icon, ImageReader, Tag, Toast } from 'mand-mobile'
import { availablect, getpayorderinfo, cancelorder, downorder, organization, uploadimage } from '@/request/api'

export default {
	name: 'buyinrdetail',
	components: {
		[topback.name]: topback,
		[iconimg.name]: iconimg,
		vuejsCountDown,
		[Icon.name]: Icon,
		[ImageReader.name]: ImageReader,
		[Tag.name]: Tag,
	},

	data() {
		return {
			selectorValue: "",
			available_ct: [],
			isSelectorShow: false,
			ctid: "",
			orderdata: {},
			end: "",
			imageList: [],
			canceldialog: {
				open: false,
				btns: [
					{
						text: 'continue to pay',
						handler: this.onDialogCancel,
					},
					{
						text: 'Cancel',
						handler: this.onDialogConfirm,
					},
				],
			},
			cancel_remark: "",
			cancel_reasons: [
				{ value: 'Incorrect remittance information', text: 'Incorrect remittance information' },
				{ value: "I don't want to buy it", text: "I don't want to buy it" },
			]

		}
	},
	created() {
		this.$store.dispatch("asyncupdatesiteconfig");
		this.ctid = this.$route.params.ctid;
		this.orderid = this.$route.params.orderid;
		this.get_availablect();
		this.get_detail();
	},
	mounted() {
	},

	methods: {
		onReaderSelect(name, { files }) {
			console.log(this.imageList);
			files.forEach(file => {
				console.log('[Mand Mobile] ImageReader Selected:', 'File Name ' + file.name)
			})
			Toast.loading('picture reading...')
		},
		onReaderComplete(name, { dataUrl, file }) {
			console.log(dataUrl, file)
			this.$toast.loading('Uploading...');
			uploadimage({ imagedata: dataUrl }).then((res) => {
				this.$toast.hide();
				if (res.code === 200) {
					const demoImageList = this.imageList || []
					demoImageList.push(this.$store.state.siteconfig.ApiUrl.substr(0, this.$store.state.siteconfig.ApiUrl.length - 1) + res.data.imgurl)
					this.$set(this.imageList, name, demoImageList)
				}
				else {
				}
			}).catch(() => {
				this.$toast.hide();
			});
		},
		onReaderError({ msg }) {
			Toast.failed(msg)
		},
		onDeleteImage(index) {
			const demoImageList = this.imageList || []
			demoImageList.splice(index, 1)
			this.$set(this.imageList, name, demoImageList)
		},
		confirm_payment() {
			let that = this;
			// if (this.imageList.length < 1) {
			// 	this.$toast.failed("Please upload the payment proof");
			// 	return
			// }
			
			if (this.ctid === "" || this.ctid === 'None') {
				this.$toast.failed("Please select the specified payment tool");
				return
			}

			Dialog.confirm({
				title: 'Confirm payment',
				content: 'Please confirm that you have completed the payment with the ' + this.selectorValue + ' account. If you do not complete the payment, your credit will be affected and your transactions will be limited!',
				confirmText: 'Got it',
				cancelText: 'Continue to pay',
				onConfirm: () => {
					that.$toast.loading('Loading...');
					console.log(that.imageList,);
					downorder({
						id: that.orderid,
						ctid: that.ctid,
						payment_voucher: that.imageList[0],
						bill_voucher: that.imageList.length > 1 ? that.imageList[1] : "",
						other_voucher: that.imageList.length > 2 ? that.imageList[2] : ""
					}).then(res => {
						that.$toast.hide();
						if (res.code === 200) {
							that.$toast.succeed("Successful, please wait for the system to review");
							setTimeout(() => {
								that.$router.push('/deposithistory');
							}, 1200)
						} else {
							that.$toast.failed(res.errmsg);
						}
					}).catch(error => {
						console.log(error);
						that.$toast.hide();
						that.$toast.failed("Network error, submit later");
					})
				},
			})

		},
		cancel() {
			this.canceldialog.open = true;
		},
		cancel_order() {
			let that = this;
			if (this.cancel_remark.length < 3) {
				this.$toast.failed("Why cancel ?");
				return;
			}
			this.$toast.loading('Loading...');
			cancelorder({
				id: this.orderid,
				remark: this.cancel_remark
			}).then(res => {
				this.$toast.hide();
				if (res.code === 200) {
					this.$toast.succeed("Cancel success");
					this.canceldialog.open = false;
					this.$router.back();
				} else {
					if (res.errmsg === "Collectionworker Order does not exist") {
						Dialog.alert({
							title: 'Tips',
							content: 'Order processing timed out, canceled!',
							confirmText: 'Ok',
							onConfirm: () => {
								that.$router.back();
							},
						})
					} else {
						this.$toast.failed(res.errmsg);
					}
				}
			})
		},
		onDialogCancel() {
			this.canceldialog.open = false;
		},
		onDialogConfirm() {
			this.cancel_order();
		},
		onSelectorChoose({ text, describe, id }) {
			this.selectorValue = text + "(" + describe + ")";
			this.ctid = id;

		},
		showSelector() {
			this.isSelectorShow = true;
		},
		get_detail() {
			let that = this
			this.$toast.loading('Loading...')
			getpayorderinfo({
				id: this.orderid
			}).then(res => {
				this.$toast.hide();
				if (res.code === 200) {
					that.orderdata = res.data;
					let now = new Date().getTime();
					let mtime = new Date(res.data.mtime).getTime();
					let futureTime = mtime + Number(that.$store.state.siteconfig.payorder_timeout_time) * 60000;
					if (now < futureTime) {
						let end_time = new Date(futureTime)
						that.end = end_time.toLocaleString();
					}
				} else {
					Dialog.alert({
						title: 'Tips',
						content: 'The order has expired! If you have any questions about this order, please contact customer service in time',
						confirmText: 'Ok',
						onConfirm: () => {
							that.$router.back();
						},
					})
				}
			})
		},
		get_availablect() {
			availablect().then(res => {
				if (res.code === 200) {

					if (Object.keys(res.data).length === 0) {
						this.available_ct = [{
							value: 'kyc',
							text: 'No kyc partner available',
							describe: "go Manage kyc partner link",
							disabled: false,
							id: 0
						}];
					} else {
						let a_ct = [];
						for (let i = 0; i < res.data.length; i++) {
							let obj = res.data[i];
							let a = {};
							a.value = obj.id;
							a.text = obj.text;
							a.describe = obj.account;
							a.id = obj.id;
							a.disabled = false;
							a_ct.push(a);
						}
						this.available_ct = a_ct;
						let obj = this.available_ct.find(x => String(x.id) === String(this.ctid));
						console.log(obj);
						this.selectorValue = obj.text + "(" + obj.describe + ")";
						this.ctid = obj.id;
					}
				} else {
					this.$toast.failed(res.errmsg);
				}
			})
		},
		go_deposithistory() {
			this.$router.push("/deposithistory");
		},
		go_manage_kyc() {
			this.$router.push("/kycpartner");
		},
		go_payment_tutorial() {
			this.$router.push('/newdedetailcode/' + organization + 'inrbuytutorial');
		},
		warning() {
			let that = this;
			Dialog.confirm({
				title: 'Tips',
				content: 'Please use the designated payment tool to complete the payment within the specified time. If the payment is not made within the specified time, the order will be refunded.',
				confirmText: 'Ok',
				cancelText: 'Payment tutorial',
				onConfirm: () => {},
				onCancel: () => {
					that.go_payment_tutorial();
				}
			});
		},
		onCopy() {
			let clipboard = new Clipboard('.copy')
			clipboard.on('success', () => {
				this.$toast.succeed('copy successfully');
				clipboard.destroy()
			})
			clipboard.on('error', () => {
				this.$toast.failed("Browser does not support copying")
				clipboard.destroy()
			})
		},
		get_order_status(collection_status) {
			if (collection_status === 'dispatched' || collection_status === 'reprocess') {
				return "Paying"
			}
			if (collection_status === 'inreview') {
				return 'In review'
			} else {
				return collection_status
			}
		}
	}
}

</script>
<style scoped>
.payfor >>> .md-field-item-content{
	padding-top: 0.09rem !important;
    padding-bottom: 0.2rem !important;
}
.copy {
	height: 0.6rem;
    width: 1.4rem;
    font-size: 0.23rem;
}

.cancel {
	height: 0.71rem;
	width: 1.4rem;
}

.countdown>>>.text {
	display: none;
}

.active_ct .selector-header,
.selector-footer {
	padding: 15px 40px;
	font-size: 0.37rem;
	color: #ccc;
}

.active_ct .selector-item-body {
	display: flex;
	align-items: center;
}

.active_ct .selector-item-body.selected .selector-item-content {
	color: #2f86f6;
}

.active_ct .selector-item-body.disabled {
	opacity: .3;
}

.active_ct .selector-item-body .selector-item-left {
	flex-shrink: 0;
	margin-right: 32px;
}

.active_ct .selector-item-body .selector-item-left .holder {
	display: block;
	width: 88px;
	height: 88px;
	border-radius: 44px;
	background-color: #e6e6e6;
	font-size: 32px;
	font-weight: 500;
	color: #2f86f6;
	text-align: center;
	line-height: 88px;
}

.active_ct .selector-item-body .selector-item-content {
	flex: 1;
	color: #111a34;
	font-size: 32px;
	line-height: 1.2;
}

.active_ct .selector-item-body .selector-item-content .selector-item-title {
	line-height: 1.2;
}

.active_ct .selector-item-body .selector-item-content .selector-item-brief {
	color: #858b9c;
	font-size: 24px;
	line-height: 1.4;
	margin-top: 8px;
}


.md-example-child-reader .image-reader-list {
	float: left;
	width: 100%;
}

.md-example-child-reader .image-reader-list .image-reader-item {
	position: relative;
	float: left;
	width: 23.5%;
	padding-bottom: 23.5%;
	margin-bottom: 2%;
	margin-right: 2%;
	background: #fff;
	box-shadow: 0 5px 20px rgba(197, 202, 213, 0.25);
	box-sizing: border-box;
	list-style: none;
	border-radius: 4px;
	background-size: cover;
	overflow: hidden;
}

.md-example-child-reader .image-reader-list .image-reader-item:nth-of-type(4n) {
	margin-right: 0;
}

.md-example-child-reader .image-reader-list .image-reader-item.add .md-icon {
	position: absolute;
	top: 40%;
	left: 50%;
	transform: translate(-50%, -50%);
	opacity: 0.5;
}

.md-example-child-reader .image-reader-list .image-reader-item.add p {
	position: absolute;
	top: 50%;
	left: 0;
	width: 100%;
	margin-top: 15px;
	font-size: 22px;
	color: #ccc;
	text-align: center;
}

.md-example-child-reader .image-reader-list .image-reader-item .image-reader-item-del {
	position: absolute;
	top: 0;
	right: 0;
	z-index: 3;
	opacity: 0.8;
}

.md-example-child-reader .image-reader-list .image-reader-item .image-reader-item-del .md-icon-close {
	font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/views/recharge/buyinrdetail.vue